import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select'
import { finYearListTodo } from '../../LMS_Redux/LMS_Slices/Hr/FinYearList';
import { salaryListTodo } from '../../LMS_Redux/LMS_Slices/Hr/SalaryList';
import { FaEye } from 'react-icons/fa6';
import { generatePaySlipTodo } from '../../LMS_Redux/LMS_Slices/Hr/GeneratePaySlip';
import { toast, ToastContainer } from 'react-toastify';

export default function SalaryList() {

    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(true)
    const [currentYear, setCurrentYear] = useState()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const year = useSelector(state => state?.finYearList?.data?.data)
    const salary = useSelector(state => state?.salaryList?.data?.data)
    // console.log(currentYear)

    const year_option = year?.map(val => (
        { value: val?.vfin_year_name, label: val?.vfin_year_name }
    ))

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'MONTH',
            field: 'vmonth',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
        },
        {
            headerName: 'SALARY AMOUNT',
            field: 'salary',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
        },
        {
            headerName: 'PAID AMOUNT',
            field: 'paid_amt',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <FaEye size={20} className='eye'
                        onClick={() => generate_pay_slip(params?.data)}
                        data-tooltip-id='view'
                        data-tooltip-content="View Pay Slip"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='view' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            autoHeight: true,
        }
    ]);

    const generate_pay_slip = (data) => {

        setLoading(true)
        dispatch(generatePaySlipTodo({ year: data?.vfin_year_name, month: data?.imonth_id })).then((res) => {
            if (res?.payload?.success) {
                setLoading(false)
                window.open(res?.payload?.data, "_blank")
            } else {
                setLoading(false)
                toast.error(res?.payload?.message, { position: "bottom-right" })
            }
        })
    }

    const change_fin_year = (year) => {
        setLoading(true);

        Promise.all([
            dispatch(salaryListTodo({ year: year })),
        ]).finally(() => setLoading(false));
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await dispatch(finYearListTodo());
                const data = res?.payload?.data?.[0];

                if (data?.vfin_year_name) {
                    setCurrentYear({ value: data.vfin_year_name, label: data.vfin_year_name });

                    await Promise.all([
                        dispatch(salaryListTodo({ year: data.vfin_year_name })),
                    ]);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header row'>
                    <div className="col-md-10">
                        <span className='icon2'>Salary List</span>
                    </div>

                    <div className="col-md-2">
                        <Select
                            closeMenuOnSelect={true}
                            options={year_option}
                            value={currentYear}
                            name='leave_type'
                            onChange={(option) => {
                                setCurrentYear(option);
                                change_fin_year(option?.value)
                            }}
                            placeholder=""
                            classNamePrefix="select"
                        />
                    </div>
                </div>


                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <>
                        {salary?.length ?
                            <DataTables
                                rowData={salary}
                                columnDefs={columnDefs}
                            />
                            :
                            <div className='wrapper-admin'>
                                <div className='text-center'>
                                    <h5>Salary List Not Found</h5>
                                </div>
                            </div>
                        }
                    </>
                }

            </div>

            <ToastContainer />
        </>
    );
}